import React from "react";
import { Modal, Button } from "react-bootstrap";

const MultipleFormModal = ({
  handleModalClose,
  showSuccessModal,
  submittedDomains,
  responseData,
}) => {
  return (
    <>
      <Modal show={showSuccessModal} onHide={handleModalClose} centered>
        <Modal.Header className="px-2 py-1">
          <Modal.Title className="fs-5">
            Report Generation in Progress
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-start">
          <p>{responseData?.message}</p>
          <ul>
            {responseData?.domains?.map((domain, index) => (
              <li key={index}>{domain}</li>
            ))}
          </ul>
        </Modal.Body>
        <div className="w-100 text-center mb-3">
          <Button
            className="px-3 py-1 fs-6 border-0"
            style={{ background: "linear-gradient(135deg, #1e40af, #3b82f6)" }}
            onClick={handleModalClose}
          >
            Got it
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default MultipleFormModal;
